import React from "react";
import styles from "./SlidingHeaderMenu.module.scss";
import classNames from "classnames";
import SlidingMenu from "./SlidingMenu";
import { PopoverContext } from "../Popover";
import { Heading, keys } from "./../../";

export default React.forwardRef(({title, Icon, ActionButton, HeaderContents, children, isActive, closeTrigger, className, containerClassName, maskClassName, top, Footer, contentClassName, showOnlyTitle = false}, ref) => {
    return (
        <SlidingMenu top={top} isActive={isActive} closeTrigger={closeTrigger} className={containerClassName} maskClassName={maskClassName}>
            <div ref={ref} className={classNames(styles.base, className)}
                onKeyDown={(e) => {
                    if (e.keyCode === keys.escape) {
                        closeTrigger(e, true);
                    }
                }}>
                <div className={classNames(styles.header, showOnlyTitle ? styles["title-center"] : '')}>
                    <div className={styles.title}>
                        {Icon && <Icon className={styles.icon}/>}
                        <Heading level={16} color="text-title">{title}</Heading>
                    </div>
                    { !showOnlyTitle && ActionButton && <ActionButton/>}
                    { !showOnlyTitle && HeaderContents && <HeaderContents/>}
                </div>
                <PopoverContext className={classNames(styles['container'], contentClassName)}>
                    {children}
                </PopoverContext>
                {Footer && <Footer/>}
            </div>
        </SlidingMenu>
    );
});

